export const generateStatesLoadingCode = (countryCode: string) => `states.${countryCode}`
export const generateTownsLoadingCode = (stateCode: string) => `towns.${stateCode}`
